module.exports = __webpack_public_path__ + "img/2-1_08.d9a6a524.jpg";